/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_TocInputs */

const en_mk_tut_toc = /** @type {(inputs: Mk_Tut_TocInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contents`)
};

const id_mk_tut_toc = /** @type {(inputs: Mk_Tut_TocInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daftar isi`)
};

/**
* | output |
* | --- |
* | "Contents" |
*
* @param {Mk_Tut_TocInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_toc = /** @type {((inputs?: Mk_Tut_TocInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_TocInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_toc(inputs)
	return en_mk_tut_toc(inputs)
});